<template>
   <div>
     <el-table :data="tableData"  :cell-style="levelColor" border v-loading="listLoading" min-height="200"  max-height="700"  style="width: 100%">
          <el-table-column 
           v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          align="center"
          :label="item.label"> 
          </el-table-column>

          <el-table-column label="开关操作" align="center" min-width="80">
            <template slot-scope="scope">
                <el-switch :value ="switchStatus(scope.row.system_status_text)"   active-color="#13ce66" inactive-color="#ff4949"   @change="switchControl(scope.row)"  style="margin-right:5px;"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="130">
            <template slot-scope="scope">
                <el-button size="mini" type="success" @click="viewDetails(scope.row)">查看</el-button>
                <el-button size="mini" type="primary"  icon="el-icon-edit" @click="fixWarning(scope.row)" v-if="update_button">编辑</el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="delleteWarning(scope.row)" v-if="destroy_button">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleList"
        />
   </div>
</template>

<script>
import pagination from "@/components/pagination/index";

export default {
  components: { pagination },
  name: 'tablePagination',
  props: {
    tableData:{
      type: Array
    },
    tableColumn:{
      type: Array
    },
    total:{
      type: Number
    },
    listQuery:{
      type: Object
    },
    listLoading:{
      type: Boolean,
      default:false
    },
    switchName:{
      type: String,
      default:false
    },
    update_button:{
      type: Boolean,
      default:false
    },
    destroy_button:{
      type: Boolean,
      default:false
    },
  },
   data() {
    return {
    };
  },
  methods: {
    switchStatus(item){
      if(item == "开启"){
        return true
      }
      else if(item == "关闭"){
        return false
      }
    },
     levelColor({row, column,rowIndex, columnIndex }){
              if(columnIndex == 9){
                if(row.system_status_text == "开启"){
                  return 'color:#30de7d;'
                }
                else if(row.system_status_text == "关闭"){
                  return 'color:red;'
                }
              }
        if(columnIndex == 6){
                if(row.phone_status_text == "开启"){
                  return 'color:#30de7d;'
                }
                else if(row.phone_status_text == "关闭"){
                  return 'color:red;'
                }
        }
     },
    handleList(){
      this.$emit("handleList");
    },
    switchControl(item){
      this.$emit("switchControl",item);
    },
    viewDetails(item){
      this.$emit("viewDetails",item);
    },
    fixWarning(item){
      this.$emit("fixWarning",item);
    },
    delleteWarning(item){
      this.$emit("delleteWarning",item);
    },
  }
}
</script>